function copunswiper(){new Swiper(".coupon_code_list_items",{loop:!1,slidesPerView:1.9,paginationClickable:!0,spaceBetween:5,breakpoints:{749:{slidesPerView:"auto",spaceBetween:30,pagination:{el:".swiper-pagination3",clickable:!0}}}})}customElements.get("quick-add-modal")||customElements.define("quick-add-modal",class e extends ModalDialog{constructor(){super(),this.modalContent=this.querySelector('[id^="QuickAddInfo-"]')}hide(e=!1){let t=document.querySelector("cart-notification")||document.querySelector("cart-drawer");t&&t.setActiveElement(this.openedBy),this.modalContent.innerHTML="",e&&(this.openedBy=null),super.hide()}show(e){e.setAttribute("aria-disabled",!0),e.classList.add("loading"),e.querySelector(".loading__spinner").classList.remove("hidden"),fetch(e.getAttribute("data-product-url")).then(e=>e.text()).then(t=>{let i=new DOMParser().parseFromString(t,"text/html");this.productElement=i.querySelector('section[id^="MainProduct-"]'),this.productElement.classList.forEach(e=>{(e.startsWith("color-")||"gradient"===e)&&this.modalContent.classList.add(e)}),this.preventDuplicatedIDs(),this.removeDOMElements(),this.setInnerHTML(this.modalContent,this.productElement.innerHTML),window.Shopify&&Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.ProductModel&&window.ProductModel.loadShopifyXR(),this.removeGalleryListSemantic(),this.updateImageSizes(),this.preventVariantURLSwitching(),super.show(e)}).finally(()=>{e.removeAttribute("aria-disabled"),e.classList.remove("loading"),e.querySelector(".loading__spinner").classList.add("hidden")})}setInnerHTML(e,t){e.innerHTML=t,e.querySelectorAll("script").forEach(e=>{let t=document.createElement("script");Array.from(e.attributes).forEach(e=>{t.setAttribute(e.name,e.value)}),t.appendChild(document.createTextNode(e.innerHTML)),e.parentNode.replaceChild(t,e)})}preventVariantURLSwitching(){let e=this.modalContent.querySelector("variant-selects");e&&e.setAttribute("data-update-url","false")}removeDOMElements(){let e=this.productElement.querySelector("pickup-availability");e&&e.remove();let t=this.productElement.querySelector("product-modal");t&&t.remove();let i=this.productElement.querySelectorAll("modal-dialog");i&&i.forEach(e=>e.remove())}preventDuplicatedIDs(){let e=this.productElement.dataset.section;this.productElement.innerHTML=this.productElement.innerHTML.replaceAll(e,`quickadd-${e}`),this.productElement.querySelectorAll("variant-selects, product-info").forEach(t=>{t.dataset.originalSection=e})}removeGalleryListSemantic(){let e=this.modalContent.querySelector('[id^="Slider-Gallery"]');e&&(e.setAttribute("role","presentation"),e.querySelectorAll('[id^="Slide-"]').forEach(e=>e.setAttribute("role","presentation")))}updateImageSizes(){copunswiper();let e=this.modalContent.querySelector(".product"),t=e.classList.contains("product--columns");if(!t)return;let i=e.querySelectorAll(".product__media img");if(!i.length)return;let r="(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";e.classList.contains("product--medium")?r=r.replace("715px","605px"):e.classList.contains("product--small")&&(r=r.replace("715px","495px")),i.forEach(e=>e.setAttribute("sizes",r))}});
/**** calculate delivery date ****/
$(document).on('click', 'button.check-btn', function(e){
  e.preventDefault();
   $('p.delivery-details-content').show().html(' ');
   e.preventDefault();  
  var date_val = $('#zipcode').val();
  if(date_val == ''){
    $('p.delivery-details-content').html("Please enter Zipcode");
    $('p.delivery-details-content').fadeOut(2500);
  }else{
    $('p.delivery-details-content').html("Please enter valid Zipcode");
   var days=[],zipcode=[],bbt_data=[],lot_BBBTdata=[],obj = {};
     // var zipcodelist= 'https://cdn.shopify.com/s/files/1/0034/7901/1441/files/deyga-zipcodelist.csv'
    var zipcodelist= zipUrl;
    var data;
    $.ajax({
      type: "GET",  
      url: zipcodelist,
      dataType: "text",       
      success: function(response) {
        var matched =false;
        var count  = 1;
       data = $.csv.toArrays(response);
        var length = data.length;
        for(var i=1;i<data.length;i++){
          count = count+1;
         var data1= data[i];
          var zipcode_aray_val = data1[0]
          // console.log(zipcode_aray_val)
           zipcode.push(data[i]);
          days.push(data[i][1]);
          obj[data[i][0]] = data[i][1];
          var enterZipcodes = $('#zipcode').val();
         if(zipcode_aray_val === enterZipcodes){
           matched = true;
           var matched_day_val = data1[1];
           var days_gap=0;
           if(matched_day_val.indexOf('to') > -1){
             if(matched_day_val.indexOf('days') >-1){
               days_gap = parseInt(matched_day_val.split('to')[1].split('days')[0]);
             }
             matched_day_val=parseInt(matched_day_val.split('to')[0]);
             
           }else{
              matched_day_val=parseInt(matched_day_val);
           }
            deliveryDate(matched_day_val,days_gap);
            }
          if(count == data.length && matched ==  false){
          $('p.delivery-details-content').fadeOut(2500);
        }
           }
        console.log(zipcode);
        
     submitFormAll(zipcode,days);
       }
    });
  }
});


function deliveryDate(matched_day_val,day_gap){
  //alert(day_gap);
     var today = new Date();
      var futureDate = new Date(today);
      futureDate.setDate(today.getDate() + matched_day_val);
      var dd = String(futureDate.getDate()).padStart(2, '0');
      var mm = String(futureDate.getMonth() + 1).padStart(2, '0'); 
      var yyyy = futureDate.getFullYear();
      var formattedDate = mm + '/' + dd + '/' + yyyy;
     var futureDatePlus8Days = new Date(futureDate);
      futureDatePlus8Days.setDate(futureDate.getDate() + day_gap);
      var ddPlus8 = String(futureDatePlus8Days.getDate()).padStart(2, '0');
      var mmPlus8 = String(futureDatePlus8Days.getMonth() + 1).padStart(2, '0');
      var yyyyPlus8 = futureDatePlus8Days.getFullYear();
      var formattedDatePlus8 = mmPlus8 + '/' + ddPlus8 + '/' + yyyyPlus8;
    var inputDates =formattedDate;
var parts = inputDates.split('/');
var date = new Date(parts[2], parts[0] - 1, parts[1]);
var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var dayOfWeek = daysOfWeek[date.getDay()];
var month = months[date.getMonth()];
var day = date.getDate();
var suffix;
if (day % 10 === 1 && day !== 11) {
  suffix = 'st';
} else if (day % 10 === 2 && day !== 12) {
  suffix = 'nd';
} else if (day % 10 === 3 && day !== 13) {
  suffix = 'rd';
} else {
  suffix = 'th';
}
var formattedDate = `${dayOfWeek}, ${month} ${day}${suffix}`;
         
/**** before delivery date end ***/

 /**** after delivery date end ***/   
  var inputDate =formattedDatePlus8;
var parts = inputDate.split('/');
var date = new Date(parts[2], parts[0] - 1, parts[1]);
var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var dayOfWeek = daysOfWeek[date.getDay()];
var month = months[date.getMonth()];
var day = date.getDate();
var suffix;
if (day % 10 === 1 && day !== 11) {
  suffix = 'st';
} else if (day % 10 === 2 && day !== 12) {
  suffix = 'nd';
} else if (day % 10 === 3 && day !== 13) {
  suffix = 'rd';
} else {
  suffix = 'th';
}
var formattedDatefinal = `${dayOfWeek}, ${month} ${day}${suffix}`;
    // var final_delivery_date = "Delivery between:" +  formattedDate + " to " + formattedDatefinal;
  if(day_gap == 0){
      var final_delivery_date = `Delivery between: <strong>${formattedDate} `;
  }else{
     var final_delivery_date = `Delivery between: <strong>${formattedDate} to ${formattedDatefinal}</strong>`;
  }
 $('p.delivery-details-content').html(final_delivery_date);
  }

  
function   submitFormAll(zipcode,days){
     var zipcode = zipcode
     var days = days;
     var enterZipcode = $('#zipcode').val();
     var data = jQuery.inArray( enterZipcode,zipcode); 
  
}
